<template>
  <div>
    <input :type="type" v-bind="$attrs" v-model="senha" />
    <i
      class="mdi mdi-eye"
      v-if="show_password"
      @click.stop="show_password = !show_password"></i>
    <i
      class="mdi mdi-eye-off"
      v-else
      @click.stop="show_password = !show_password"></i>
  </div>
</template>
<script>
export default {
  props: ["value"],
  data() {
    const Senha = this.value;
    return {
      show_password: false,
      Senha,
    };
  },
  computed: {
    type() {
      const show = !!this.show_password;
      return show ? "text" : "password";
    },
    senha: {
      get() {
        return this.Senha;
      },
      set(value) {
        this.Senha = "";
        this.Senha = value;
        this.$emit("input", value);
      },
    },
  },
  updated() {
    this.Senha = this.value;
  },
};
</script>

<style lang="less" scoped>
div {
  position: relative;
  margin-top: 0.25em;
  input {
    height: 55px; /* Definir a altura aqui */
    margin-top: 0 !important;
  }
  i {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    padding: 0.5em;
  }
}
</style>
